import { render, staticRenderFns } from "./NavbarFooter.vue?vue&type=template&id=ae062024&"
import script from "./NavbarFooter.vue?vue&type=script&lang=js&"
export * from "./NavbarFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports